import { useEffect } from 'react';
export const useClearUpponOptionsClosing = ({ setHovered, optionsAreOpen, }) => {
    useEffect(() => {
        if (!optionsAreOpen)
            setHovered(false);
    }, [optionsAreOpen, setHovered]);
};
